import { useMemo } from 'react'
import { useSectionId } from '@v4/components/common/SectionItem'
import { breakpointValues } from '@v4/utils/theme'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Testimonial7.styled'

export const useTestimonial7 = props => {
	const { metaData } = props
	const sectionId = useSectionId()

	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const columnsNumber = Math.min(metaData.columns?.toNumber(), _.size(items))
	const classes = useStyles({ ...props, columnsNumber })

	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const centerMode = !!metaData.centerMode?.toBoolean()
	const infinite = !!metaData.infinite?.toBoolean()
	const dots = !!metaData.dots?.toBoolean()

	const sliderConfig = useMemo(
		() => ({
			className: classes.slider,
			dots,
			infinite,
			speed: 500,
			slidesToShow: columnsNumber,
			slidesToScroll: columnsNumber,
			arrows: false,
			centerMode,
			responsive: [
				{
					breakpoint: breakpointValues.md,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						initialSlide: 1,
						adaptiveHeight: true,
					},
				},
			],
		}),
		[centerMode, classes.slider, columnsNumber, dots, infinite],
	)

	return [
		{
			classes,
			items,
			rounding: metaData.imageRounding?.toNumber(),
			sliderConfig,

			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			titleEditable,
			titleKey: metaData.title?.tierKey,
		},
		{
			handleTitleClick,
			handleTitleChange,
		},
	]
}
